import { FetchMethodTypes, FetchMethods, encodeParams, generateBodyParams } from '@alluradirect/react';
import { IS_DIRECT_VACATIONS } from 'config/envSetup';

import { GenerateBodyDataArgs } from './types';
import { fetchOptions } from '@alluradirect/react';
import { isDirectVacations } from 'config/brand';
import { isGuestAppURL } from 'helpers/urlHelpers';

// Formats the data depending on the scenario, isCustom, isSubform or default
export const generateBodyData = ({ isCustomSendData, isSubform, values, isSendMethod }: GenerateBodyDataArgs) => {
  if (!isSendMethod) {
    return null;
  }

  let body = values;

  if (!isCustomSendData) {
    if (isSubform) {
      body = generateBodyParams({ form_data: encodeParams({ values }) });
    } else if (values && typeof values === 'object' && !(values instanceof FormData) && !(values instanceof URLSearchParams)) {
      const params = new URLSearchParams();
      Object.entries(values).forEach(([key, val]) => {
        if (val !== undefined && val !== 'undefined') {
          params.append(key, String(val));
        }
      });
      body = params;
    } else {
      body = new URLSearchParams(values);
    }
  }

  return body;
};

// If we are data that is already formatted, remove the default 'Content-Type' header
export const generateFetchOptions = ({ isCustomSendData }: { isCustomSendData: boolean }) => {
  const fetchOpts = JSON.parse(
    JSON.stringify({
      ...fetchOptions,
      headers: {
        ...fetchOptions.headers,
      },
    }),
  );

  if (isCustomSendData) {
    delete fetchOpts.headers['Content-Type'];
  }

  return fetchOpts;
};

// add is_direct_vactions param to every guest request to help server send data
export const generateURL = ({ endpoint }: { endpoint: string }): string => {
  const isGuestApp = isGuestAppURL();
  if (!isGuestApp) {
    return endpoint;
  } else {
    const url = new URL(endpoint);
    url.searchParams.set(
      'is_direct_vacations',
      isDirectVacations({ isDV: IS_DIRECT_VACATIONS(), isGuestApp: true }) ? '1' : '0',
    );
    return url.toString();
  }
};

export function isSendMethod(method: FetchMethods | FetchMethodTypes) {
  return method === 'POST' || method === 'PUT' || method === 'DELETE';
}
